const translations = {
    application: 'Application',
    applicationIsRequired: 'Application is required'
};

export default translations;
